import { render, staticRenderFns } from "./DetalleVehiculo.vue?vue&type=template&id=705ec060"
import script from "./DetalleVehiculo.vue?vue&type=script&lang=js"
export * from "./DetalleVehiculo.vue?vue&type=script&lang=js"
import style0 from "./DetalleVehiculo.vue?vue&type=style&index=0&id=705ec060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports